<template>
  <v-container>
    <!-- 使用 v-if 來控制 Dialog 的顯示，關閉時銷毀內容 -->
    <v-dialog v-if="dialogVisible" v-model="dialogVisible" persistent max-width="400px">
      <v-card class="pa-4">
        <v-card-title>
          <span class="headline">信用卡</span>
        </v-card-title>
        <v-row>
          <v-col>
            <p>請輸入信用卡號與有效期限</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div ref="tapiframeContainer"></div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <p>信用卡卡號&nbsp;&nbsp;<span :style="`color:${TPstatus.number ? 'green' : 'red'}`">
                格式{{ TPstatus.number ? '正確' : '錯誤' }}</span></p>
            <p>有效期限&nbsp;&nbsp;&nbsp;&nbsp;<span :style="`color:${TPstatus.expiry ? 'green' : 'red'}`">
                格式{{ TPstatus.expiry ? '正確' : '錯誤' }}</span></p>
          </v-col>
        </v-row>
        <v-card-actions class="justify-end">
          <v-btn @click="closeDialog('cancel')" color="red">取消</v-btn>
          <v-btn @click="closeDialog('confirm')" color="green">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      TPstatus: {
        canGetPrime: false,
        number: false,
        expiry: false,
      },
    };
  },
  mounted() {
  },
  methods: {
    openDialog() {
      this.TPstatus = {
        canGetPrime: false,
        number: false,
        expiry: false,
      };
      this.dialogVisible = true;
      // 返回 Promise，並在 DOM 更新後進行下一步操作
      return new Promise((resolve) => {
        this.resolve = resolve;
        // 使用 $nextTick 確保 DOM 更新完成後再創建 div
        this.$nextTick(() => {
          this.createTapPayDiv();
          // 這裡確保 Promise 被解決，表示 Dialog 打開並完成初始化
        });
      });
    },
    async closeDialog(action) {
      if (action === 'confirm' && this.TPstatus.canGetPrime === false) {
        return;
      }
      // 根據按鈕選擇返回不同的結果
      let result = null;
      if (action === 'confirm') {
        result = await new Promise((resolve) => {
          TPDirect.card.getPrime((res) => {
            if (res.status === 0) {
              resolve({ prime: res.card.prime });
            } else {
              resolve(null); // 失敗時仍然 resolve，避免程式卡住
            }
          });
        });
      }
      // 傳回結果給 Promise
      if (this.resolve) {
        await this.resolve(result);
      }
      // 在這裡移除動態創建的 div 元素
      this.removeTapPayDiv();
    },
    async createTapPayDiv() {
      const container = this.$refs.tapiframeContainer;
      // 動態創建 div 元素
      const tapPayIframe = document.createElement('div');
      tapPayIframe.id = 'tappay-iframe'; // 設置 id
      container.appendChild(tapPayIframe);
      // 確保 dom
      await new Promise((resolve) => setTimeout(resolve, 100));
      // 這裡設置 TPDirect 的初始化
      try {
        const defaultCardViewStyle = {
          color: 'rgb(0,0,0)',
          fontSize: '15px',
          lineHeight: '24px',
          fontWeight: '300',
          errorColor: 'red',
          placeholderColor: '',
        };
        const config = {
          isUsedCcv: false,
          isMaskCreditCardNumber: true,
          maskCreditCardNumberRange: {
            beginIndex: 6,
            endIndex: 11,
          },
        };
        const tap = document.getElementById('tappay-iframe');
        await new Promise((resolve) => {
          TPDirect.card.setup(tap, defaultCardViewStyle, config);
          resolve(); // 假設 setup 是同步的，直接 resolve
        });
        TPDirect.card.onUpdate((update) => {
          this.TPstatus.canGetPrime = update.canGetPrime;
          this.TPstatus.number = update.status.number === 0;
          this.TPstatus.expiry = update.status.expiry === 0;
        });
      } catch (error) {
        console.error('Error during setup:', error);
      }
    },
    removeTapPayDiv() {
      this.dialogVisible = false;
      const tapPayIframe = document.getElementById('tappay-iframe');
      if (tapPayIframe) {
        // 移除動態創建的 div 元素
        tapPayIframe.remove();
      }
      // 清空 resolve，確保每次調用都重新設置
      this.resolve = null;
    },
  },
};
</script>
